export function getView(charge) {
  return charge.type_id && !charge.insurance_code_id
}
